import Vue from 'vue'
import Router from 'vue-router'

import authSvc from './core/authSvc'
import { appRoutes } from './app/router'
import accountRoutes from './account/router'
import i18n from './i18n'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: '/paycallback',
      redirect: to => {
        window.top.postMessage('payment_callback')
        return '/'
      }
    },
    // {
    //   path: '/',
    //   redirect: appRoutes.path
    // },
    accountRoutes,
    appRoutes
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.meta.allowUnauthorized && !authSvc.curUser) {
    next(accountRoutes.name)
  } else {
    document.title = to.meta.title ? i18n.t(to.meta.title) : 'WebPay'
    next()
  }
})

export default router
